import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ThumbnailFormatterWrapper = styled.div`
  margin: -${Spacing.S12} 0;
`
